import {
    //Поиск
    CHANGE_PHONES_SEARCH,
    START_PHONES_SEARCH,
    CLEAR_PHONES_SEARCH,
    CHECK_PHONE_SUCCESSFULLY,
    UNBLOCK_PHONE_FAILED,
    UNBLOCK_PHONE_SUCCESSFULLY,
    CHECK_PHONE_FAILED
  } from '../actions/blockedPhones';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  phoneSearch: '',
  activePhoneSearch: '',
  canUnblock: false,
  isBlocked: false,
  isVerified: false,
}

export default function (state = INITIAL_STATE, action) { 
    switch (action.type) {
        //Поиск
    case CHANGE_PHONES_SEARCH:
        return {
          ...state,
          phoneSearch: action.payload.value
        };
      case START_PHONES_SEARCH:
        return {
          ...state,
          isBlocked: false,
          isVerified: false,
          activePhoneSearch: action.payload.value,
        };
      case CLEAR_PHONES_SEARCH:
        return {
          ...state,
          activePhoneSearch: INITIAL_STATE.activePhoneSearch,
          phoneSearch: INITIAL_STATE.phoneSearch,
        };
      case CHECK_PHONE_SUCCESSFULLY:
        return {
          ...state,
          canUnblock: action.result,
        };
      case UNBLOCK_PHONE_FAILED:
        return {
          ...state,
          canUnblock: false,
        };
      case UNBLOCK_PHONE_SUCCESSFULLY:
        return {
          ...state,
          canUnblock: false,
          activePhoneSearch: INITIAL_STATE.activePhoneSearch,
          phoneSearch: INITIAL_STATE.phoneSearch,
        };
      case CHECK_PHONE_FAILED:
        return {
          ...state,
          isBlocked: action.isBlocked ? action.isBlocked : state.isBlocked,
          isVerified: action.isVerified ? action.isVerified : state.isVerified,
        };        
      case SIGN_OUT:
        return INITIAL_STATE;
      default:
        return state;
    }
}